<template>
  <div class="p-5  bg-white rounded-lg" v-if="ready">
    <aron-table uploadEndpoint="/uploadFile" :endPoint="route" filterEndpoint="search_rawjoinlists" :filter="filter"
      :key="route" :viewOnly="viewOnly" :showActionButton="showActionButton" :formType="formType"></aron-table>
  </div>
</template> 
   
<script>
import { mapGetters, mapState } from "vuex";
import AronTable from "./tblmainMtbe.vue";
export default {
  components: {
    AronTable,
  },
  data() {
    return {
      route: "rawjoinlists",
      formType: "sidebarRightSide",
      ready: false,
      viewOnly: true,
      showActionButton: true,
    };
  },
  computed: {
    ...mapGetters({
      getProjectSelected: "auth/getProjectSelected",

    }),
    filterEndpoint() {
      return "rawjoinlists";
    },
    filter() {
      return { advanceFilter: { pkId: this.getProjectSelected['id'] } };
    },
    getUserInfo() {
      var UserInfo = localStorage.getItem("userInfo");
      if (UserInfo != null && UserInfo != "") {
        var agensi = JSON.parse(UserInfo);
        // this.filter = { agensiId: agensi.agensiID }; 
        this.ready = true;
        return JSON.parse(UserInfo);
      }

      return { name: "", email: "", role: "" };
    },
  },

  watch: {
    $route(to, from) {
      this.getUserInfo();
    },
  },
  created() {
    console.log("getUserInfo:", this.getUserInfo.role);
    this.ready = true;

  },

};
</script>

